<ng-container *ngIf="wiki">
  <a [class]="aClass" [href]="wiki.href || '#'" [attr.target]="openNewTab ? '_blank' : undefined" [style.order]="order">
    <mat-icon class="menu-icon">question_mark</mat-icon>
    <span class="menu-label">Wiki</span>
  </a>
</ng-container>
